import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { Search, X } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const INPUT = 'w-full h-9 rounded-md pl-9 pr-8 text-sm bg-white dark:bg-[#1A1D24] border border-black/[0.12] dark:border-white/[0.08] text-[#0F0F0F] dark:text-white placeholder-[#A1A1AA] dark:placeholder-zinc-500';

export const CreatorPicker = ({ value, onChange }) => {
  const [q, setQ] = useState('');
  const [results, setResults] = useState([]);
  const [open, setOpen] = useState(false);
  const timer = useRef(null);

  useEffect(() => {
    clearTimeout(timer.current);
    if (q.trim().length < 2) { setResults([]); return undefined; }
    timer.current = setTimeout(() => {
      axios.get(`${API_URL}/api/creator-ideation/creators`, { params: { q }, withCredentials: true })
        .then(({ data }) => { setResults(data.creators); setOpen(true); })
        .catch(() => setResults([]));
    }, 250);
    return () => clearTimeout(timer.current);
  }, [q]);

  if (value) {
    return (
      <div className="h-9 flex items-center justify-between rounded-md px-3 text-sm bg-[#FF451A]/[0.06] border border-[#FF451A]/30 text-[#0F0F0F] dark:text-white" data-testid="creator-ideation-selected-creator">
        <span className="truncate">{value.name} {value.instagram_handle && <span className="text-[#6B6B6B] dark:text-zinc-400">@{value.instagram_handle}</span>}</span>
        <button type="button" onClick={() => onChange(null)} className="text-[#6B6B6B] hover:text-[#FF451A]" data-testid="creator-ideation-clear-creator"><X size={14} /></button>
      </div>
    );
  }

  return (
    <div className="relative">
      <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#A1A1AA]" />
      <input value={q} onChange={(e) => setQ(e.target.value)} onFocus={() => results.length && setOpen(true)} onBlur={() => setTimeout(() => setOpen(false), 150)} placeholder="Search by name or @handle" className={INPUT} data-testid="creator-ideation-creator-search" />
      {open && results.length > 0 && (
        <div className="absolute z-20 mt-1 w-full max-h-64 overflow-y-auto rounded-lg border border-black/[0.12] dark:border-white/[0.08] bg-white dark:bg-[#1A1D24] shadow-lg" data-testid="creator-ideation-creator-results">
          {results.map((c) => (
            <button type="button" key={c.id} onMouseDown={() => { onChange(c); setQ(''); setOpen(false); }} className="w-full text-left px-3 py-2 hover:bg-black/[0.04] dark:hover:bg-white/5 transition-colors" data-testid={`creator-ideation-creator-option-${c.id}`}>
              <div className="text-sm text-[#0F0F0F] dark:text-white">{c.name} {c.instagram_handle && <span className="text-[#6B6B6B] dark:text-zinc-400">@{c.instagram_handle}</span>}</div>
              <div className="text-[11px] text-[#6B6B6B] dark:text-zinc-400 truncate">{[c.category, c.city].filter(Boolean).join(' · ') || '—'}</div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
